export const ORG_LIST = [
  "중앙구조본부",
  "서울소방재난본부",
  "인천소방본부",
  "부산소방본부",
  "대구소방안전본부",
  "대전소방본부",
  "광주소방본부",
  "울산소방본부",
  "세종소방본부",
  "경기도소방본부",
  "경기북부소방본부",
  "강원도소방본부",
  "충청북도소방본부",
  "충청남도소방본부",
  "전라북도소방본부",
  "전라남도소방본부",
  "경상북도소방본부",
  "경상남도소방본부",
  "제주도소방본부",
];

export const EQP_LIST = [
  "펌프",
  "물탱크",
  "화학",
  "험지",
  "구조",
  "구급",
  "헬기",
  "지휘",
  "회복",
  "행정",
  "위성",
  "기타차량",
];

/** 비소방 동원자원 — 차량종류(eqp) 값 */
export const NON_FIRE_EQP_LIST = [
  "소방의소대",
  "경찰(인원)",
  "군(인원)",
  "공무원(인원)",
];

export const ALL_EQP_LIST = [...EQP_LIST, ...NON_FIRE_EQP_LIST];

export const TRAIN_NON_FIRE_RATIO = 0.2;

export const DEFAULT_EXCEL_HEADER = [
  "연번",
  "시도",
  "소방서",
  "안전센터",
  "차량종류",
  "차량명칭",
  "차량번호",
  "탑승총인원",
  "선탑자명",
  "선탑전화번호",
  "자원집결지",
  "연락관",
  "비고",
];

export const FIELD_KEYS = [
  "sido",
  "fireStation",
  "safetyCenter",
  "eqp",
  "callsgn",
  "plateNo",
  "sumnum",
  "name",
  "pnum",
  "rdvs",
  "cntct",
  "remark",
];

export const VALIDATION_EXCLUDED_FIELDS = [
  "plateNo", // 차량번호
  "name", // 선탑자명
  "cntct", // 연락관
  "remark", // 비고
];

export const VALIDATABLE_FIELDS = [
  "sido",
  "eqp",
  "callsgn",
  "pnum",
  "rdvs",
];

export const TRAIN_CONDITIONS_STORAGE_KEY = "mfm_bulk_train_conditions";
